import { useEffect } from 'react'
import { useState } from 'react'
import styled from 'styled-components'

export default function ProductInfoTab({ currTab, onChageTab }) {
  const [activeTab, setActiveTab] = useState('product_info')

  const handleTabClick = (e) => {
    const tabVal = e.target.getAttribute('data-tab')
    setActiveTab(tabVal)

    if (onChageTab) {
      onChageTab(tabVal)
    }
  }

  useEffect(() => {
    if (currTab) {
      setActiveTab(currTab)
    }
  }, [currTab])

  return (
    <TabWrapper>
      <TabList>
        <TabItem
          className={activeTab === 'product_info' && 'active'}
          onClick={handleTabClick}
          data-tab="product_info"
        >
          제품소개
        </TabItem>
        <TabItem
          className={activeTab === 'tutorial' && 'active'}
          onClick={handleTabClick}
          data-tab="tutorial"
        >
          인증방법
        </TabItem>
        <TabItem className={activeTab === 'qa' && 'active'} onClick={handleTabClick} data-tab="qa">
          문의
        </TabItem>
      </TabList>
    </TabWrapper>
  )
}

const TabWrapper = styled.div`
  position: sticky;
  margin-bottom: calc(100vw * (25 / 375));
  top: 0;
  background: #fff;
  z-index: 100;
`

const TabList = styled.ul`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: calc(100vw * (10 / 375)) 0;
`

const TabItem = styled.li`
  border-radius: calc(100vw * (84 / 375));
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  text-align: center;
  padding: calc(100vw * (11 / 375));
  color: #989898;
  cursor: pointer;

  &.active {
    font-weight: 700;
    background: #4e4e4e;
    color: #fff;
  }
`
